<template>
    <div :class="{ 'esconder-no-pwa-instalado': isPwaInstalled }">
    <div v-if="podeInstalar" @click="promoverInstalacao"
            class="cursor-pointer block p-4 bg-white text-color border-round-sm border-300 mb-4 flex gap-3 align-items-center ">
            <div class=" pi pi-download mr-3 text-2xl text-color-secondary"></div>
            <div>
                <div class="mb-2">Instalar App</div>
                <div class="text-sm text-color-secondary">Clique aqui para adicionar o app ao seu dispositivo</div>
            </div>
        </div>
    </div>
    
</template>

<script setup>
import { ref, onMounted } from 'vue';

const podeInstalar = ref(false);
let deferredPrompt;

const isPwaInstalled = ref(window.matchMedia('(display-mode: standalone)').matches);


onMounted(() => {
    window.matchMedia('(display-mode: standalone)').addEventListener('change', (e) => {
        isPwaInstalled.value = e.matches;
    });
    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        deferredPrompt = e;
        podeInstalar.value = true;
    });

    window.addEventListener('appinstalled', () => {
        podeInstalar.value = false;
    });
});

const promoverInstalacao = async () => {
    if (deferredPrompt) {
        deferredPrompt.prompt();

        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === 'accepted') {
            console.log('Usuário aceitou a instalação do PWA');
        } else {
            console.log('Usuário não aceitou a instalação do PWA');
        }

        deferredPrompt = null;
        podeInstalar.value = false;
    }
};



</script>

<style>
.esconder-no-pwa-instalado {
  display: none;
}

</style>